import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  CheckCircle as CheckCircleFill,
  ArrowRight,
  Home,
  Mail,
} from "lucide-react";

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  return (
    <section
      style={{
        margin: "85px 0px 80px 0px",
        minHeight: "50vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <div
          style={{
            background: "#ffffff",
            maxWidth: "480px",
            margin: "auto",
            borderRadius: "20px",
            padding: "25px 30px",
            boxShadow: "0 15px 40px rgba(0, 0, 0, 0.2)",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative Elements */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, #667eea, #764ba2)",
            }}
          />

          {/* Success Icon with Animation */}
          <div
            style={{
              width: "50px",
              height: "50px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
              animation: "bounceIn 0.6s ease-out",
            }}
          >
            <CheckCircleFill
              style={{
                fontSize: "30px",
                color: "#ffffff",
              }}
            />
          </div>

          {/* Description */}
          <div
            style={{
              color: "#718096",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            <p style={{ marginBottom: "12px" }}>
              Your account has been created successfully!
            </p>

            {/* Payment Info */}
            <div style={{ textAlign: "left", background: "#fff" }}>
              <div
                style={{
                  background: "#fef3c7",
                  borderRadius: "8px",
                  padding: "10px",
                  border: "1px solid #fde68a",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    color: "#92400e",
                    fontWeight: 500,
                    marginBottom: 0,
                  }}
                >
                  Since you have registered under a non-accredited institution,
                  your application will undergo a verification process. After
                  successful verification, you will be able to proceed with the
                  payment, and your account will be approved accordingly. For
                  further assistance, please contact{" "}
                  <a
                    href="mailto:secretary@aiota.org"
                    style={{
                      color: "#92400e",
                      textDecoration: "underline",
                      fontWeight: 600,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    secretary@aiota.org
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              maxWidth: "260px",
              margin: "12px auto 0",
            }}
          >
            <Button
              variant="outline"
              onClick={() => navigate("/")}
              style={{
                background: "transparent",
                border: "2px solid #e2e8f0",
                padding: "6px 20px",
                fontWeight: 600,
                borderRadius: "8px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                transition: "all 0.3s ease",
                color: "#4a5568",
                cursor: "pointer",
                width: "100%",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#f7fafc";
                e.target.style.borderColor = "#cbd5e0";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.borderColor = "#e2e8f0";
                e.target.style.transform = "translateY(0)";
              }}
            >
              <Home size={14} />
              Back to Home
            </Button>
          </div>
        </div>
      </Container>

      {/* Add keyframe animation */}
      <style>
        {`
          @keyframes bounceIn {
            0% {
              transform: scale(0.3);
              opacity: 0;
            }
            50% {
              transform: scale(1.05);
              opacity: 0.8;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </section>
  );
};

export default RegistrationSuccess;
